import { useEffect, useRef } from "react";
import HighchartsReact from "highcharts-react-official";
import {
  ForwardChartOptions,
  useForwardPoints,
} from "../Utilities/CoTraderUtils";
import Highcharts from "highcharts";
import Boost from "highcharts/modules/boost";
import { useResolvedDark } from "../../../ThemeProvider/ThemeContext";
import ChartLoader from "../../Common/ChartLoader";

const CoTraderBarChart = ({
  selectedSymbol,
  tenor,
  setTenorList,
  isDark: isDarkProp,
  layoutVersion = 0,
}) => {
  const isDark = useResolvedDark(isDarkProp);
  const { forwardPoints, isLoading } = useForwardPoints(selectedSymbol, setTenorList);
  const chartOptions = ForwardChartOptions({
    forwardPoints,
    selectedSymbol,
    tenor,
    isDark,
  });
  const chartRef = useRef(null);
  const chartWrapperRef = useRef(null);
  Boost(Highcharts);

  useEffect(() => {
    const chart = chartRef.current?.chart;
    const chartContainer = chartWrapperRef.current;

    if (!chart || !chartContainer) {
      return undefined;
    }

    let frameId = null;
    const syncChartToContainer = () => {
      // Skip while the kept-alive tab is hidden (display:none, 0x0).
      if (chartContainer.getClientRects().length === 0) return;
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
      }

      frameId = requestAnimationFrame(() => {
        chart.setSize(
          chartContainer.clientWidth,
          chartContainer.clientHeight,
          false
        );
        chart.reflow();
      });
    };

    syncChartToContainer();

    const resizeObserver =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(() => syncChartToContainer());

    resizeObserver?.observe(chartContainer);

    return () => {
      resizeObserver?.disconnect();
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
      }
    };
  }, [forwardPoints?.length, layoutVersion, selectedSymbol, tenor]);

  return (
    <div
      ref={chartWrapperRef}
      className="w-100 h-100"
      style={{ minHeight: 0, position: "relative" }}
    >
      {isLoading && <ChartLoader dim isDark={isDark} />}
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{
          style: { height: "100%", width: "100%", zIndex: "0" },
        }}
      />
    </div>
  );
};

export default CoTraderBarChart;
